<template>
  <vue-loadmore
    :on-refresh="refresh"
    :on-loadmore="load"
    :finished="finished">
    <el-card class="box-card item" v-for="(item,index) in lists" :key="index">
      <!-- s -->
      <div class="ah-tab-content-wrapper">
        <div class="ah-tab-content ">
          <!-- 单个order-list -->
          <div class="order-list">
            <div class="order-cell weui-cell">
              <div class="order-num">
                <span decode="true">
                  订&ensp;单&ensp;号：
                </span>
              </div>
              <div class="order-num-info">{{item.out_pay_on}}</div>
              <button @click="doCopy(item.out_pay_on)" class="order-copy">复制</button>
            </div>
            <div class="order-des weui-line ">
              <div class="order-info ">
                <div class="weui-cell order-cell">
                  <div class="order-num">订单状态：</div>
                  <div>{{item.statusinfo}}</div>
                </div>
                <div class="weui-cell order-cell">
                  <div class="order-num">订单类型：</div>
                  <div>{{item.typename}}</div>
                </div>
                <div class="weui-cell order-cell ">
                  <div class="order-num en">Account：</div>
                  <div>{{item.AccountNo}}</div>
                </div>
                <div class="weui-cell order-cell ">
                  <div class="order-num en">Identifier：</div>
                  <div>{{item.Identifier}}</div>
                </div>
                <div class="weui-cell order-cell ">
                  <div class="order-num">订单金额：</div>
                  <div>PHP{{item.price}}</div>
                </div>
                <div class="weui-cell order-cell ">
                  <div class="order-num">手续费：</div>
                  <div>PHP{{item.service_price}}</div>
                </div>
                <div class="weui-cell  order-cell ">
                  <div class="order-num">订单时间：</div>
                  <div>{{item.pay_time}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </vue-loadmore>
</template>

<script>
  export default {
    name: 'historycard',
    // 组件注册
    components: {
    },
    data() {
      return {
        lists: [],
        page: 0,
        pageSize: 10,
        finished: false
      }
    },
    mounted() {
      this.load();
    },
    methods: {
      refresh(done) {
        this.list = [];
        this.page = 0;
        this.finished = false;
        this.load();
        done();
      },
      load(done) {
        let auth_token = localStorage.getItem('auth_token');
        if (auth_token) {
          this.page++;
          this.$api
            .request('Member/getLifeRecords', {page: this.page, pageSize: this.pageSize})
            .then(({ data }) => {
              if (data.length <= 0 || data.length < this.pageSize) {
                this.finished = true;
              } else {
                this.finished = false;
              }
              data.forEach(item => {
                this.lists.push(item);
              });
            })
            .catch(error => {
              this.$message({
                message: error + "加载充值记录失败！",
                type: "warning"
              })
            });
        }
        if (done) {
          done();
        }
      },
      doCopy(msg){
        this.$copyText(msg).then((e) => {
          this.$message({
            type: 'success',
            message: '复制成功！'
          });
        }, (e) => {
          this.$message({
            type: 'warning',
            message: '复制失败！'
          });
        })
      },
    }

  }
</script>
<style scoped>
  * {
    font-size: 14px !important;
  }

  .text {
    font-size: 28rpx;
  }

  .box-card {
    margin-bottom: 5px;
  }

  .order-list>div.order-cell:first-child {
    font-weight: 700;
  }

  .order-list {
    margin-bottom: 10rpx;
    border-radius: 30rpx;
    padding: 20rpx;
    background-color: #fff;
    overflow: hidden;
    margin-top: 20rpx;
  }

  .order-info {
    font-weight: 400;
    color: #999
  }

  .order-des {
    position: relative
  }

  .weui-cell {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    font-weight: 400;
    position: relative
  }

  .order-cell .order-num {
    width: 25%;
    padding-left: 0;
    text-align: center;

  }

  .order-cell .order-type {
    color: #e4393c;
    font-size: 24rpx;

  }

  .order-cell .order-num-info {
    text-align: left;
    font-size: 28rpx;
    width: 60%;
    overflow: hidden;
    text-overflow: ellipsis;

  }

  .empty {
    padding: 60rpx 20rpx;
    margin: 0 auto;
    text-align: center
  }

  .empty:after {
    content: "'没有更多内容'";
    text-align: center;
    color: #e43;
    font-size: inherit;
    font-size: .186667rem
  }

  .infinite-list {
    height: 99vh;

  }
</style>



// WEBPACK FOOTER //
// src/page/lifehistory.vue